import { delay, put } from 'redux-saga/effects';
import { displayNotification } from '../actions/notification';
import * as Types from '../actions/types';
import { Config, Messages, Routes } from '../../config';
import {
  axiosFailedStatus,
  axiosResetStatus,
  axiosSuccessStatus
} from '../actions/axiosStatusNotification';
import { push } from 'connected-react-router'
import { userInfo, tokenDetails } from 'store/actions/user';

export function* errorCatch(e, cases) {
  yield put(axiosFailedStatus());

  if (e?.response && e.response.status) {
    if (cases && cases[e.response.status]) {
      if (typeof cases[e.response.status] === 'function') {
        yield cases[e.response.status]();
      } else if (cases[e.response.status] !== 'concat') {
        yield put(displayNotification(Types.NOTIFICATION_ERROR, cases[e.response.status]));
      } else {
        let messages;

        if (e && e.response && e.response.data && typeof e.response.data.message === 'string') {
          messages = e.response.data.message;
        } else {
          let error = '';
          messages = [];

          for (error in e.response.data.message) {
            messages = messages.concat(e.response.data.message[error]);
          }
        }

        yield put(displayNotification(Types.NOTIFICATION_ERROR, messages));
      }
    } else {
      if (e.response.status === 401) {
        // Clean user Info in State
        yield put(tokenDetails());
        yield put(userInfo());
        yield put(displayNotification(Types.NOTIFICATION_ERROR, Messages.UNAUTHENTICATED_ERROR));
        yield delay(Config.DELAY_REDIRECT);

        // Redirect user
        yield put(push(Routes.ROUTE_LOGIN));
        return;
      }
      yield put(displayNotification(Types.NOTIFICATION_ERROR, Messages.GENERIC_ERROR_MESSAGE));
    }
  } else {
    yield put(displayNotification(Types.NOTIFICATION_ERROR, Messages.GENERIC_ERROR_MESSAGE));
  }

  yield delay(Config.DELAY_NOTIFICATION);
  yield put(axiosResetStatus());
}

export function* genericError() {
  yield put(displayNotification(Types.NOTIFICATION_ERROR, Messages.GENERIC_ERROR_MESSAGE));
  yield delay(Config.DELAY_NOTIFICATION);
  yield put(axiosResetStatus());
}

export function* successCall(showMessage, message) {
  if (showMessage)
    yield put(displayNotification(Types.NOTIFICATION_SUCCESS, message || Messages.GENERIC_SUCCESS_MESSAGE));

  yield put(axiosSuccessStatus());
  yield delay(Config.DELAY_NOTIFICATION);
  yield put(axiosResetStatus());
}

export function checkListResponse(response) {
  return response && response.data && response.data.data &&
    Array.isArray(response.data.data) && response.data.data.length;
}
